<style lang="less" scoped>
.contents {
  // width: 1200px;
  // padding: 35px 0 30px;
  box-sizing: border-box;
  margin: 0 auto;
}

.members {
  background: #fff;
  padding: 55px 10px 10px;
  box-sizing: border-box;

  h2 {
    color: #101010;
    font-family: "PingFang SC Medium";
    font-weight: 550;
    font-size: 1.125rem;
    margin-bottom: 15px;
    padding-left: 0.3125rem;
    text-align: center;
  }
  /deep/.ivu-form-item {
    margin-bottom: 1.25rem;
  }
  /deep/.ivu-form-item-label {
    font-size: 10px;
  }
  /deep/.ivu-input {
    font-size: 10px;
  }
  .form {
    h3 {
      font-size: 12px;
      margin: 5px 0;
      color: #000;
    }
  }
}

.footer {
  text-align: center;
  margin: 20px 0;

  .submit {
    width: 100px;
    background: #2811ce;
    color: #fff;
    height: 30px;
    line-height: 30px;
    border-radius: 25px;
    margin-left: 5px;
  }
}
.title {
  margin-top: 25px !important;
}
.codeSubimt {
  background: #2811ce;
  height: 30px;
  line-height: 30px;
  font-size: 12px;
  border-radius: 25px;
}
/deep/textarea.ivu-input {
  min-height: 100px;
}
/deep/.ivu-form-item-error-tip {
  font-size: 11px;
}
</style>
<template>
  <section>
    <enHeader></enHeader>
    <div class="contents">
      <div class="members">
        <!-- <h2>CSTR Membership Enquiry</h2> -->
        <div class="form">
          <Form ref="formValidate" :model="formValidate" :rules="ruleValidate">
            <h3>Organization Details</h3>
            <FormItem label="Organization" prop="Organization">
              <Input
                v-model="formValidate.Organization"
                placeholder="Full name of your organization"
              ></Input>
            </FormItem>
            <FormItem label="Country" prop="Country">
              <Input
                v-model="formValidate.Country"
                placeholder="Your Country"
              ></Input>
            </FormItem>
            <FormItem label="Website">
              <Input
                v-model="formValidate.Website"
                placeholder="Landing page of the organization"
              ></Input>
            </FormItem>
            <FormItem label="Address">
              <Input
                v-model="formValidate.Address"
                placeholder="Your Address"
              ></Input>
            </FormItem>
            <h3 class="title" style="margin-bottom: 15px">
              Registered Resource Type
            </h3>
            <FormItem prop="desc">
              <Input
                v-model="formValidate.desc"
                type="textarea"
                placeholder="Types of resources to would like to be registered for CSTR, such as science data, publication, preprint, newsletters, etc."
              ></Input>
            </FormItem>
            <h3 class="title">Contact Details</h3>
            <FormItem label="Applicant" prop="Applicant">
              <Input
                v-model="formValidate.Applicant"
                placeholder="Full name of the applicant"
              ></Input>
            </FormItem>
            <FormItem label="Email" prop="Email">
              <Input v-model="formValidate.Email" placeholder="Email"></Input>
            </FormItem>
          </Form>
          <div slot="footer" class="footer">
            <Button class="submit" @click="handleSubmit('formValidate')"
              >Register</Button
            >
          </div>
        </div>
      </div>
    </div>
    <Modal
      v-model="modal2"
      :title="this.$t('apply.apply7')"
      class="verticalModal"
    >
      <div style="display: flex; justify-content: space-between">
        <Input
          v-model="formValidate.imgCode"
          style="width: 250px"
          placeholder="Vertification Code"
        ></Input>

        <el-image
          class="image"
          :src="getImgCaptchaImage"
          @click="getCaptchaCode"
          :title="this.$t('apply.apply4')"
        ></el-image>
      </div>
      <div slot="footer">
        <Button
          style="color: #fff"
          type="primary"
          class="codeSubimt"
          size="large"
          long
          @click="dataRegister"
          >Submit</Button
        >
      </div>
    </Modal>

    <ComFooter></ComFooter>
  </section>
</template>

<script >
import enHeader from "@/components/enHeader.vue";
import ComFooter from "@/components/footer.vue";
import ComMenu from "@/components/menu.vue";

export default {
  inject: ["reload"],
  components: {
    enHeader,
    ComMenu,
    ComFooter,
  },
  data() {
    return {
      getImgCaptchaImage: "",
      uuid: "",
      lang: "en",
 
      modal2: false,
      formValidate: {
        Organization: "",
        Country: "",
        Website: "",
        imgCode: "",
        Address: "",
        desc: "",
        Applicant: "",
        Email: "",
      },
      ruleValidate: {
        Organization: [
          {
            required: true,
            message: "Full name of your organization",
            trigger: "change",
          },
        ],
        Country: [
          {
            required: true,
            message: "This field is required.",
            trigger: "change",
          },
        ],
        Website: [
          {
            required: true,
            message: "This field is required.",
            trigger: "change",
          },
        ],
        Address: [
          {
            required: true,
            message: "This field is required.",
            trigger: "change",
          },
        ],
        Applicant: [
          {
            required: true,
            message: "This field is required.",
            trigger: "change",
          },
        ],
        desc: [
          {
            required: true,
            message: "This field is required.",
            trigger: "change",
          },
        ],
        Email: [
          {
            required: true,
            message: "This field is required.",
            trigger: "change",
          },
          {
            type: "email",
            message: "Incorrect email format",
            trigger: "change",
          },
        ],
      },
    };
  },
  mounted() {
    
  },
  methods: {
    getRSApass(mag) {
      let jse = new this.$jsEncrypt();
      //公钥
      let publicString =
        "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCASph/ydFbA8T4uieDZeTnqFivJu8QH7fZfbo3w2ULeZ/JJ5+3RSe8i+kvoZcn8Vdy3RIXi9xEy/OCKOCk6CvnaHEtLgA20DKBWbhD7SIn5UoNJP2E6S/ytSw7BCesENVSl+9iIrze9nuKeZ0982R0itUCTwjBB7Yw1mg+1QanGQIDAQAB";
      jse.setPublicKey(publicString);
      // 加密内容
      return jse.encrypt(mag);
    },

    guid2() {
      function S4() {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
      }
      return (
        S4() +
        S4() +
        "-" +
        S4() +
        "-" +
        S4() +
        "-" +
        S4() +
        "-" +
        S4() +
        S4() +
        S4()
      );
    },
    getCaptchaCode() {
      this.uuid = this.guid2();
      var api = "https://www.cstr.cn/openapi/v2/";
      this.getImgCaptchaImage =
        api +
        `pid-user-service/captcha/getCaptchaImage?captchaId=` +
        this.uuid +
        "&time=" +
        new Date().getTime();
    },
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.axios({
            method: "post",
            // url: "pid-user-service/Membership.reg?checkCodeKey=" + this.uuid,
            url: "pid-user-service/Membership.reg",
            data: {
              organization: this.formValidate.Organization,
              country: this.formValidate.Country,
              website: this.formValidate.Website,
              address: this.formValidate.Address,
              resourceType: this.formValidate.desc,
              applicant: this.formValidate.Applicant,
              email: this.formValidate.Email,
              code: this.getRSApass(this.formValidate.Email),
              //   checkCodeKey: this.guid2(),

              //   code: this.$jsEncrypt(this.formValidate.imgCode),
            },
          }).then((res) => {
            if (res.data.code == 200) {
              this.$router.push({
                path: "/en/search/message",
              });
            } else if (res.data.code == 500) {
              this.$Message.warning(res.data.message);
            }
          });
          //   this.modal2 = true;
          //   this.getCaptchaCode();
        } else {
          //   this.$Message.error("Fail!");
        }
      });
    },
    dataRegister() {
      this.axios({
        method: "post",
        url: "pid-user-service/Membership.reg?checkCodeKey=" + this.uuid,
        data: {
          organization: this.formValidate.Organization,
          country: this.formValidate.Country,
          website: this.formValidate.Website,
          address: this.formValidate.Address,
          resourceType: this.formValidate.desc,
          applicant: this.formValidate.Applicant,
          email: this.formValidate.Email,
          //   checkCodeKey: this.guid2(),
          code: this.formValidate.imgCode,
        },
      }).then((res) => {
        if (res.data.code == 200) {
          this.modal2 = false;
          this.$router.push({
            path: "/en/search/message",
          });
        } else if (res.data.code == 500) {
          this.modal2 = false;
          this.$Message.warning(res.data.message);
        }
      });
    },
  },
};
</script>